<!-- รายการขอแก้ไขแปลงของ supzone -->
<div class="row">
    <div class="col-lg-12">
        <div id="listRequest" class="card card-outline card-success ml-2 mr-2">
            <div class="card-header">
                <h3 class="card-title "><span class="headText2">รายการขอแก้ไขข้อมูลแปลงอ้อยของท่าน</span></h3>
                <div class="card-tools ">
                    <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                            class="fas fa-expand"></i></button>
                    <button (click)="requestData();" type="button" class="btn btn-tool text-primary"><i
                            class="fas fa-sync-alt"></i></button>
                    <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                            class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="card-body table-responsive p-2" style="height: 500px">
                    <table #tb_data class="table table-hover table-head-fixed text-nowrap">
                        <thead>
                            <tr class="headText text-primary">
                                <th>วันที่</th>
                                <th>ข้อมูลแปลง</th>
                                <th>หัวข้อ</th>
                                <th>สถานะ</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of dataApi">
                                <td class="align-middle">{{ item.date_add | adtob }}</td>
                                <td class="align-middle">
                                    {{ item.intlandno }} {{ item.fmname }} {{ item.canetype }}
                                    {{ item.landvalue }} ไร่ รูท {{ item.route }}
                                </td>
                                <td>{{ item.edit_type_name }}</td>
                                <td>{{ item.edit_status_doc }}</td>
                                <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                <td class="text-center align-middle">
                                    <!-- <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                            data-bs-target="#explan_plant">
                                            <i class="fas fa-edit"></i>
                                        </a> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
